import { PaginationType, Table } from '@octano/global-ui';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationsKeys } from '../../../../locales/translations';
import { ITEMS_PER_PAGE_DEFAULT } from '../../../ClosingPeriod/ClosingPeriod';
import { useAcademicOffers } from '../loaders/AcademicOffersLoader';
import { useColumns } from '../hooks/useColumns';
import { CeAcademicOffer } from '../types';

export function AcademicOffersTable() {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_ACADEMIC_OFFERS,
  );
  const { data, loading, query, updateQuery } = useAcademicOffers();

  const refresh = useCallback(() => {
    updateQuery({ ...query });
  }, [query, updateQuery]);

  const results = useMemo(() => {
    return data?.data ?? [];
  }, [data]);

  const paginationTable = useMemo<PaginationType | undefined>(() => {
    if (data) {
      return {
        totalItems: data.total,
        onChangePage: (page) => updateQuery({ ...query, page }),
        itemsPerPage: ITEMS_PER_PAGE_DEFAULT,
        totalPages: data.total_pages,
        currentPage: query.page ?? 1,
      };
    } else return undefined;
  }, [data, query, updateQuery]);

  const columns = useColumns({ onDelete: refresh });

  return (
    <Table<CeAcademicOffer>
      columns={columns}
      data={results}
      isLoadingResults={loading}
      noResultsText={t('table.noResults')}
      pagination={paginationTable}
    />
  );
}
